export default __webpack_public_path__ + "static/media/wrong-network.f1a43d83.svg";